export const changeLanguage = (langName) => {
	return {
		type: "UPDATE_LANGUAGE",
		language: langName
	}
}
